<template>
	<div class="wrap-container-appmain">
		<div class="nav-left-menu">
			<div class="user-interface">
				<div class="user-avatar" @click="jumpChange">
					<img :src="userInfo.user_head_img" alt="" />
				</div>
				<div class="user-name">
					<div class="name">
						{{ userInfo.real_name || userInfo.user_code_name }}
					</div>
					<div
						class="user-tag level"
						v-if="userInfo.user_is_member_grade"
						:style="`background:url(${grade[userInfo.user_is_member_grade].icon}) no-repeat`"
					>
						<!-- <img
              :src="grade[userInfo.user_is_member_grade].icon"
              class="level-icon"
              alt=""
            /> -->
					</div>
				</div>
				<div class="user-statistics">
					<div class="user-integral">
						<div class="user-int-cash-title">
							<img class="user-int-cash-icon" src="../assets/icon/jf@2x.png" alt="" />
							<div class="name">积分</div>
						</div>
						<div class="user-int-cash-num">{{ userInfo.user_score }}</div>
					</div>
					<div class="user-cash">
						<div class="user-int-cash-title">
							<img class="user-int-cash-icon" src="../assets/icon/xj@2x.png" alt="" />
							<div class="name">现金</div>
						</div>
						<div class="user-int-cash-num">{{ userInfo.user_price }}</div>
					</div>
				</div>
			</div>
			<!-- 用户界面 end-->
			<navMenuVue
				class="nav-menu"
				@getSideBar="getSideBar"
				v-if="list.length > 0"
				:list="list"
			></navMenuVue>

			<div
				class="nsl-aaxx"
				:data-nsl="nsl ? nsl_t : ''"
				@click="nsla"
				:class="{
					'nsl-hover': nsl,
				}"
			></div>
		</div>
		<div class="view-content">
			<transition name="el-fade-in" mode="out-in">
				<router-view v-if="list.length > 0" :key="key" />
			</transition>
		</div>
	</div>
</template>

<script>
	import navMenuVue from '../components/navMenu.vue';
	import { $authRoleList } from '@/api';
	import { mapState } from 'vuex';
	export default {
		name: 'PersonalCenter',
		components: {
			navMenuVue,
		},
		computed: {
			...mapState({
				userInfo: 'userInfo',
			}),
			key() {
				return this.$route.path;
			},
		},
		data() {
			return {
				list: [],
				nsl_t: unescape(this.$nsl0),
				nsl: false,
				grade: {
					// 0=普通,1=普通,2=白银,3=黄金,4=铂金,5=钻石
					0: {
						name: '普通会员',
						icon: require('@/assets/icon/pthy@2x.png'),
					},
					1: {
						name: '普通会员',
						icon: require('@/assets/icon/pthy@2x.png'),
					},
					2: {
						name: '白银会员',
						icon: require('@/assets/icon/byhy@2x.png'),
					},
					3: {
						name: '黄金会员',
						icon: require('@/assets/icon/hjhy@2x.png'),
					},
					4: {
						name: '铂金会员',
						icon: require('@/assets/icon/bjhy@2x.png'),
					},
					5: {
						name: '钻石会员',
						icon: require('@/assets/icon/zshy@2x.png'),
					},
				},
				// userInfo: {},
			};
		},
		beforeCreate() {},
		created() {
			this.$nextTick(() => {
				this.getSideBar();
			});
		},
		beforeMount() {},
		mounted() {
			// console.log(this.$store.state.userInfo);
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		methods: {
			/**
			 * 获取 左侧导航栏数据
			 */
			getSideBar() {
				$authRoleList({}).then((res) => {
					if (res) {
						this.$data.list = res.data;
						this.$store.commit('setPermissions', res.data);
					}
				});
			},

			// 点击头像跳转到 个人信息页
			jumpChange() {
				if (this.$route.name == 'personalinfo') return;

				let url = this.list.filter((item) => {
					return item.name == '我的资料';
				})[0];

				this.$router.push({
					path: url.children[0].route.path,
				});
			},
			nsla() {
				this._nsl$1++;
				if (this._nsl$1 == this._nsl$2) {
					this.nsl = true;
					this._nsl$1 = 0;
					setTimeout(() => {
						this.nsl = false;
					}, 3000);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.wrap-container-appmain {
		position: relative;
		width: 100%;
		display: flex;
		justify-content: flex-start;
		// align-items: center;
		min-height: 900px;
		// height: 100vh;
		background-color: #fff;

		.view-content {
			padding-bottom: 20px;
			flex-grow: 1;
			// height: 100vh;
			min-height: 900px;
			overflow: hidden;
			background: rgba(240, 242, 245, 1);
		}
		.view-content::-webkit-scrollbar {
			/*滚动条整体样式*/
			width: 4px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 4px;
		}

		.view-content::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
			background: #e60000;
			cursor: pointer !important;
		}

		.view-content::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
			border-radius: 10px;
			background: rgba(255, 255, 255, 0.1);
		}
		.user-interface {
			box-sizing: border-box;
			padding-top: 32px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 260px;
			// border: 1px solid #000;

			.user-avatar {
				width: 88px;
				height: 88px;
				// background: rgba(24, 144, 255, 1);
				border-radius: 50%;

				img {
					cursor: pointer;
					border-radius: 50%;
					width: 100%;
					height: 100%;
				}
			}

			.user-name {
				width: 96%;
				font-size: 24px;

				font-weight: bold;
				line-height: 22px;
				color: #333333;
				.name {
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					text-align: center;
					padding: 4px 0px;
				}
				.user-tag {
					position: relative;
					margin: 0px auto;
					margin-top: 8px;
					box-sizing: border-box;
					width: 100px;
					height: 23.3px;
					background-position: center;
					-webkit-background-position: center;
					background-size: 100% !important;
					-webkit-background-size: 100% !important;
				}

				.level-icon {
					width: 100%;
					height: 100%;
				}
			}
		}
		.user-statistics {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 40px;
			// border: 1px solid #000;

			.user-cash,
			.user-integral {
				position: relative;
				display: flex;
				justify-content: flex-start;
				flex-direction: column;
				flex-grow: 0;
				flex-shrink: 1;
				width: 50%;
				height: 100%;
			}
			.user-int-cash-icon {
				position: relative;
				top: 1px;
				margin-left: 24px;
				margin-right: 8px;
				width: 16px;
				height: 16px;
			}
			.user-integral::after {
				content: '';
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				right: -1px;
				width: 1px;
				height: 20px;
				background: rgba(238, 238, 238, 0.39);
			}
			.user-int-cash-title {
				display: flex;
				font-size: 12px;

				font-weight: 400;
				color: #999999;
			}
			.user-int-cash-num {
				box-sizing: border-box;
				margin-top: 4px;
				padding: 0px 4px;
				text-align: center;
				font-size: 14px;

				font-weight: bold;
				color: #333333;
			}
		}
		.nav-left-menu {
			position: relative;
			z-index: 10;
			width: 250px;
			box-shadow: 2px -6px 6px rgba(0, 0, 0, 0.16);
			min-height: 900px;
			flex-shrink: 0;
			.nav-menu {
				box-sizing: border-box;
				// padding-left: 10px;
			}
		}
	}

	.nsl-aaxx {
		position: absolute;
		bottom: 0px;
		right: 0px;
		width: 30px;
		height: 30px;
		// border: 1px solid #000;
	}
</style>
